/* global layersJSON */
import {LpAssetsResolver} from '../../assets/lp-assets-resolver';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let imagesLoadQueue: any = 0;
let loadedImages = 0;
let scaleCoeff;
type LayerConfig = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    img: any
    image: {
        src: string,
        width: number,
        height: number
    },
    depth: number,
    initialStartX: number,
    initialStartY: number,
    startX: number,
    startY: number,
    coeffX: number,
    coeffY: number,
    currentX: number,
    currentY: number,
    node: HTMLElement,
};
let parallaxConfig: LayerConfig[] = [];

function drawInitialParallax() {
    let layerHeight;
    let layerWidth;
    let index;
    const parallaxContainer = document.querySelector('.parallax-bg-container');
    let imageNode;
    let parallaxLayer;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    scaleCoeff = calculateSceneSizeModifier();

    for (index in parallaxConfig) {
        parallaxLayer = parallaxConfig[index];

        layerWidth = parallaxLayer.image.width * scaleCoeff;
        layerHeight = parallaxLayer.image.height * scaleCoeff;

        imageNode = document.createElement('img');
        imageNode.src = parallaxLayer.image.src;
        imageNode.className = 'parallax-layer';
        imageNode.style.minWidth = '100%';
        imageNode.style.minHeight = '100%';
        imageNode.style.position = 'absolute';
        imageNode.style.width = `${layerWidth}px`;
        imageNode.style.height = `${layerHeight}px`;
        parallaxLayer.initialStartX = parallaxLayer.startX;
        parallaxLayer.initialStartY = parallaxLayer.startY;
        parallaxLayer.startX += (screenWidth - layerWidth) / 2;
        parallaxLayer.startY += (screenHeight - layerHeight) / 2;
        imageNode.style.top = `${parallaxLayer.startY}px`;
        imageNode.style.left = `${parallaxLayer.startX}px`;
        imageNode.style.zIndex = `${parallaxLayer.depth}`;
        parallaxLayer.node = imageNode;
        parallaxContainer.appendChild(parallaxLayer.node);
    }

    $(window).on('resize', resizeParallax);
}

function resizeParallax() {
    let parallaxLayer;
    let layerIndex;
    let imageNode;
    let layerWidth;
    let layerHeight;
    const layers = document.getElementsByClassName('parallax-layer') as HTMLCollectionOf<HTMLImageElement>;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    scaleCoeff = calculateSceneSizeModifier();

    for (layerIndex in parallaxConfig) {
        parallaxLayer = parallaxConfig[layerIndex];
        imageNode = layers[layerIndex];

        layerWidth = parallaxLayer.image.width * scaleCoeff;
        layerHeight = parallaxLayer.image.height * scaleCoeff;
        imageNode.style.width = `${layerWidth}px`;
        imageNode.style.height = `${layerHeight}px`;
        parallaxLayer.startX = parallaxLayer.initialStartX + (screenWidth - layerWidth) / 2;
        parallaxLayer.startY = parallaxLayer.initialStartY + (screenHeight - layerHeight) / 2;
        imageNode.style.top = `${parallaxLayer.startY}px`;
        imageNode.style.left = `${parallaxLayer.startX}px`;
    }
}

function loadImages() {
    let layerIndex;


    for (layerIndex in parallaxConfig) {
        const parallaxLayerConfig = parallaxConfig[layerIndex];

        // console.log(parallaxLayerConfig);
        parallaxLayerConfig.image = new Image();
        const imageRelativePath = LpAssetsResolver.getRelativePath(parallaxLayerConfig.img);
        parallaxLayerConfig.image.src = imageRelativePath;
        // @ts-ignore
        parallaxLayerConfig.image.onload = imageOnloadHandler.bind(parallaxLayerConfig.image, layerIndex);
        // @ts-ignore
        parallaxLayerConfig.image.onerror = function handleImageLoadingError() {
            console.error(`Image load error ${imageRelativePath}`);
            imageOnloadHandler();
        };

        imagesLoadQueue += 1;
    }
}

function imageOnloadHandler() {
    loadedImages += 1;

    if (imagesLoadQueue === loadedImages) {
        allImagesLoadedHandler();
    }
}

function allImagesLoadedHandler() {
    imagesLoadQueue = [];
    // console.log(parallaxConfig);
    drawInitialParallax();
    setMouseListeners();
    document.querySelector('.parallax-loader').classList.add('parallax-loader--fade-out');
    setTimeout(function hideLoader() {
        (document.querySelector('.parallax-loader') as HTMLElement).style.display = 'none';
    }, 1000);
}

function setMouseListeners() {
    // let prevMouseX = 0;
    let newMouseX = 0;
    // let prevMouseY = 0;
    let newMouseY = 0;
    // let mouseStopped = true;

    $(document).on('mousemove', function handleMouseMovement(event) {
        // mouseStopped = false;
        newMouseX = event.originalEvent.clientX - window.innerWidth / 2;
        newMouseY = event.originalEvent.clientY - window.innerHeight / 2;
    });

    setInterval(function renderParallaxScene() {
        let parallaxElement;
        let parallaxNode;
        let index;
        const coords = [];
        let top;
        let left;


        top = 0;
        for (index in parallaxConfig) {
            parallaxElement = parallaxConfig[index];
            parallaxNode = parallaxElement.node;
            top = Math.round((newMouseY * parallaxElement.coeffY));
            left = Math.round((newMouseX * parallaxElement.coeffX));
            coords.push([left, top]);
            parallaxElement.currentX = left;
            parallaxElement.currentY = top;
        }


        for (index in parallaxConfig) {
            parallaxElement = parallaxConfig[index];
            parallaxNode = parallaxElement.node;
            parallaxNode.style.transform = `translate(${coords[index][0]}px,${coords[index][1]}px)`;
        }
    }, 30);
}

function calculateSceneSizeModifier() {
    let maxCoeff = 0;
    let maxCoeffY = 0;
    let layerConfig;
    let layerIndex;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    let minSceneWidth;
    let minSceneHeight;
    let imageWidth;
    let imageHeight;
    let scaleCoeffX;
    let scaleCoeffY;

    // console.log('screenW x screenH', [screenWidth, screenHeight]);

    for (layerIndex in parallaxConfig) {
        layerConfig = parallaxConfig[layerIndex];

        /* console.log(layerConfig.coeffX);
           console.log(layerConfig.coeffY); */

        imageWidth = layerConfig.image.width;
        imageHeight = layerConfig.image.height;

        if (Math.abs(layerConfig.coeffX) > maxCoeff) {
            maxCoeff = Math.abs(layerConfig.coeffX);
        }

        if (Math.abs(layerConfig.coeffY) > maxCoeffY) {
            maxCoeffY = Math.abs(layerConfig.coeffY);
        }
    }

    minSceneWidth = (2 * screenWidth * maxCoeff + screenWidth);
    minSceneHeight = (2 * screenHeight * maxCoeffY + screenHeight);

    scaleCoeffX = minSceneWidth / imageWidth;
    scaleCoeffY = minSceneHeight / imageHeight;

    if (imageHeight * scaleCoeffX < screenHeight) {
        scaleCoeffX = screenHeight / imageHeight;
        // console.log('Scale by height');
    }

    /* console.log('Max coeff is ' + maxCoeff);
       console.log('Img width is ' + imageWidth);
       console.log('Min scene width ' + minSceneWidth);
       console.log('Scale coeff X ' + scaleCoeffX);
       console.log('Scale coeff Y ' + scaleCoeffY);
       console.log('New image size X', [imageWidth * scaleCoeffX, imageHeight * scaleCoeffX]);
       console.log('New image size Y', [imageWidth * scaleCoeffY, imageHeight * scaleCoeffY]); */

    return scaleCoeffX > scaleCoeffY ? scaleCoeffX : scaleCoeffY;
}

$(function initParallaxBackground() {
    if (document.querySelector('.parallax-bg-container')) {
        parallaxConfig = JSON.parse(window.layersJSON);
        loadImages();
    }
});
